module.exports = __webpack_public_path__ + "media/components/assets/img/bg/footer-88da01b0d06ff7ecb4b618a29b2bfe3e.svg";